import BaseService from '_services/rest/base';

/* eslint-disable new-parens */
class PuzzleService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/puzzle`;
  }

  getUrlSave(id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${id}`,
      };
    }
    return {
      url: `${this.getUrl()}`,
    };
  }

  getList(params) {
    const filters = {
      type: params.type_id,
      cat_id: params.cat_id,
      search: params.search,
      status: params.status_id,
    };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTypesList() {
    return this.request(`${this.getUrl()}/type`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getLevelsList() {
    return this.request(`${this.getUrl()}/level`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getStatusList() {
    return this.request(`${this.getUrl()}/status`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getPuzzleById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deletePuzzle(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  save(model) {
    let formData = new FormData();
    formData = this.setFormData(model, formData);
    const meta = this.getUrlSave(model.id);
    return this.request(meta.url, formData, 'post')
      .catch(err => {
        throw err;
      });
  }
}

export default new PuzzleService();
